import { InMemoryCache } from '@apollo/client/core';
import { createClient } from '@seek/ca-graphql-client';
import { browserHttpLink } from '@seek/ca-graphql-client/browser';
import { type Brand, createAbsoluteUrl } from '@seek/melways-sites';
import { persistCache, LocalStorageWrapper } from 'apollo3-cache-persist';

import { Environment } from 'src/shared/config';
import type { ConfigContextTypes } from 'src/shared/types';
import { brandLookup } from 'src/utils/brandLookup';

const getGraphqlEndpoint = (config: ConfigContextTypes) => {
  const { country, environment, language } = config;
  const candidateGraphlUrl = createAbsoluteUrl({
    product: 'candidate',
    path: '/graphql',
    country,
    language,
  });
  if (environment === Environment.STAG) {
    return 'https://candidate-graphql-dark-prod.cloud.seek.com.au/graphql';
  }
  if (environment === Environment.PROD) {
    return candidateGraphlUrl;
  }
  return 'https://candidate-graphql-dark-prod.cloud.seek.com.au/'; // development environment
};

const gqlClient = async (window: Window) => {
  const cache = new InMemoryCache();
  // @ts-ignore
  const config = window.__config;
  const { site, locale } = config;
  const brand = brandLookup(site);

  // await before instantiating ApolloClient, else queries might run before the cache is persisted
  await persistCache({
    cache,
    storage: new LocalStorageWrapper(window.localStorage),
  });

  return createClient({
    headers: { Accept: 'application/features.seek.all+json' },
    appName: 'talent-static',
    httpLink: browserHttpLink,
    authOptions: { useAuth: false },
    cache,
    graphqlEndpointOverride: getGraphqlEndpoint(config),
    brand: brand.toLowerCase() as Brand,
    country: locale,
  });
};

export default gqlClient;
